<template>
  <OnClickOutside @trigger="hideLikePicker" :options="{ ignore: [/* ... */] }">
    <button ref="like-button" class="like-button" @click="toggleLikePicker">
      <span v-if="likeType">{{ likeIcon }}</span>
      <img v-else class="like-icon" src="@/assets/LikeIcon.svg" />
      &nbsp;<span :style="likeStyle">{{ $t(likeText) }}</span>
    </button>
  </OnClickOutside>
</template>

<script>

import LikeService from '../../service/like.service'
import { VueRenderer } from '@tiptap/vue-2'
import tippy from 'tippy.js'
import LikePicker from './LikePicker'
import { OnClickOutside } from '@vueuse/components'

export default {
  name: 'LikePostButton',
  components: { OnClickOutside },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      picker: null,
      popup: null
    }
  },
  mounted() {
    this.picker = new VueRenderer(LikePicker, {
      parent: this
    })
    this.picker.ref.$on('select', this.onLike)
    this.popup = tippy('body', {
      appendTo: () => document.body,
      content: this.picker.element,
      showOnCreate: false,
      interactive: true,
      trigger: 'manual',
      placement: 'top-start',
      zIndex: 1,
      hideOnClick: false
    })[0]
  },
  computed: {
    likeType() {
      return this.post.userLike ? this.post.userLike.type : undefined
    },
    likeIcon() {
      return LikeService.getLikeIcon(this.likeType || 'like')
    },
    likeText() {
      return LikeService.getLikeText(this.likeType || 'like')
    },
    likeStyle() {
      return LikeService.getLikeStyle(this.likeType)
    }
  },
  methods: {
    onLike(type) {
      this.popup.hide()
      return this.likeType === type ? this.unlike(type) : this.like(type)
    },
    async like(type) {
      await this.$store.dispatch('likePost', { postId: this.post.id, type })
    },
    async unlike(type) {
      await this.$store.dispatch('unlikePost', { postId: this.post.id, type })
    },
    toggleLikePicker(event) {
      if (!this.popup.state.isVisible) {
        addEventListener('scroll', this.hideLikePicker)
        if (this.$refs['like-button'].getBoundingClientRect().top <= 160) {
          this.popup.setProps({ placement: 'bottom-start' })
        } else {
          this.popup.setProps({ placement: 'top-start' })
        }
        this.popup.show()
      } else {
        removeEventListener('scroll', this.hideLikePicker)
        this.popup.hide()
      }
      this.popup.setProps({
        getReferenceClientRect: () => event.target.getBoundingClientRect()
      })
    },
    hideLikePicker() {
      removeEventListener('scroll', this.hideLikePicker)
      this.popup.hide()
    }
  },
  destroyed() {
    this.popup.destroy()
    this.picker.destroy()
  }
}
</script>

<style scoped lang="scss">
.like-button {
  background: none;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  padding: 2px 20px;
  color: $black-color;
  display: flex;
  align-items: center;
  font-size: 14px;

  span {
    pointer-events: none;
  }

  &:hover {
    background-color: color.adjust(white, $lightness: -10%);
  }
}
</style>
